import { ArrowLeftOutlined } from '@ant-design/icons';
import Background from "@components/background";
import { SCREEN, useWindowSize } from "@components/window-size-provider";
import { FocalPoint } from "@customTypes/index";
import { Button, Col, Row } from "antd";
import { useNavigate } from 'react-router-dom';
import { Link } from "@customTypes/index";
import { BackgroundShadeColor } from '@components/background/Background';

declare const SingleHeaderJustifyOptions: ["center", "start", "end", "space-around", "space-between", undefined];
export declare type SingleHeaderJustifyOption = typeof SingleHeaderJustifyOptions[number];

declare const SingleHeaderAlignOptions: ["top", "middle", "bottom", "stretch", undefined];
export declare type SingleHeaderAlignOption = typeof SingleHeaderAlignOptions[number];

interface SingleHeaderProps {
	className?: string;
	title: string | null;
	tag: string;
	description?: string;
	justify?: SingleHeaderJustifyOption;
	align?: SingleHeaderAlignOption;
	imgSrc: string;
	focalPoint?: FocalPoint;
	style?: any;
	parallax?: boolean;
	shade?: boolean | BackgroundShadeColor;
	backButton?: Link | null;
}

const defaultProps: SingleHeaderProps = {
	title: "",
	tag: "h1",
	align: "middle",
	justify: "center",
	backButton: null,
	focalPoint: {
		left: '50%',
		top: "50%"
	},
	parallax: true,
	shade: false,
	imgSrc: "https://via.placeholder.com/1000x250/E6EAED/CCCCCC/",
};

const SingleHeader = ({
	className,
	tag,
	justify,
	align, title,
	description,
	imgSrc,
	focalPoint,
	style,
	parallax,
	backButton,
	shade,
}: SingleHeaderProps) => {
	const windowDimensions = useWindowSize();
	const navigate = useNavigate();
	const css: any = ["covr-header", "covr-single-header"];
	const HeaderTag: any = `${tag}`;

	css.push(className);

	return (
		<Background
			className={css.join(" ")}
			src={imgSrc}
			size="cover"
			repeat={false}
			position={`${focalPoint?.left}% ${focalPoint?.top}%`}
			style={style}
			shade={shade}
			parallax={parallax}
		>
			<Row className='item-1'>
				<Col span={12}>
					{backButton &&
						<Button
							type="text"
							size={windowDimensions.up(SCREEN.MD)
								? "large"
								: 'middle'}
							className="text-white"
							onClick={() => navigate(backButton.url)}
						>
							<ArrowLeftOutlined
								className={windowDimensions.up(SCREEN.MD)
									? "font-20"
									: 'font-12'}
							/> Back
						</Button>}
				</Col>
			</Row>
			<Row className='item-1' justify={justify} align={align}>
				<Col>

					{title && <HeaderTag
						dangerouslySetInnerHTML={{ __html: title }}
					/>}
					{description && (<p dangerouslySetInnerHTML={{
						__html: description,
					}} />)}
				</Col>
			</Row>
		</Background>
	);
};

SingleHeader.defaultProps = defaultProps;

export default SingleHeader;
